import { useState, useRef } from 'react';
import { debounce } from '../../utils/common';
import { useTeamMemberByBadgeNumber } from '../useTeamMember/useTeamMemberByBadgeNumber';

/**
 * Hook for fetching and managing employee details with debounced lookup.
 * @returns {object} Employee state and handlers
 */
export const useEmployeeDetails = () => {
  const [empNumber, setEmpNumber] = useState('');
  const [queryEmpNumber, setQueryEmpNumber] = useState('');

  const debouncedSetRef = useRef(debounce(setQueryEmpNumber, 2000));

  const { data: employeeDetails } = useTeamMemberByBadgeNumber(queryEmpNumber);

  const empNumberChangeHandler = (e) => {
    const val = e.target.value;
    setEmpNumber(val);
    debouncedSetRef.current(val);
  };

  const reset = () => {
    setEmpNumber('');
    setQueryEmpNumber('');
  };

  return { empNumber, employeeDetails, empNumberChangeHandler, reset };
};
